export const CONTACT_EMAIL = 'domjazzasso@gmail.com';
export const CONTENTFUL_SPACE_ID = process.env.GATSBY_CONTENTFUL_SPACE_ID;
export const CONTENTFUL_DELIVERY_TOKEN = process.env.GATSBY_CONTENTFUL_DELIVERY_TOKEN;
export const HELLOASSO_URL = 'https://www.helloasso.com/associations/dom-jazz/adhesions/adhesion-association-2022';
export const FACEBOOK_GROUP = 'https://www.facebook.com/groups/domjazz';
export const GFORM_URL = 'https://forms.gle/S5RkapqTJyLyHgaG9';
